import {
  DEFAULT_LOCALE as SHARED_DEFAULT_LOCALE,
  isSupportedLocale,
} from 'simulix-shared/i18n/locales';

// The locale codes themselves live in simulix-shared so the backend can pick
// email templates from the same list. Only the presentation metadata below is
// frontend-specific.
export const DEFAULT_LOCALE = SHARED_DEFAULT_LOCALE;
export const STORAGE_KEY = 'simulix.locale';

// `vuetify` is the vuetify/es5/locale/* key, which differs from the BCP-47
// `intl` tag (zhHans, not zh-CN). `rtl` is unused today.
export const SUPPORTED_LOCALES = [
  { code: 'en', name: 'English', vuetify: 'en', intl: 'en-GB', rtl: false },
  { code: 'zh-CN', name: '中文（简体）', vuetify: 'zhHans', intl: 'zh-CN', rtl: false },
];

export const findLocale = (code) => SUPPORTED_LOCALES.find((locale) => locale.code === code);

// Requires both lists: a code present in simulix-shared but missing its
// presentation metadata here would leave findLocale() undefined and break the
// $vuetify/rtl watcher in main.js.
export const isSupported = (code) => isSupportedLocale(code) && Boolean(findLocale(code));

export function detectBrowserLocale() {
  const candidates = [...(navigator.languages || []), navigator.language].filter(Boolean);

  // Exact match first, then primary subtag ("zh" -> "zh-CN").
  const exact = candidates.find(isSupported);
  if (exact) {
    return exact;
  }

  const byPrefix = candidates
    .map((candidate) =>
      SUPPORTED_LOCALES.find((locale) => locale.code.split('-')[0] === candidate.split('-')[0])
    )
    .find(Boolean);

  return byPrefix ? byPrefix.code : DEFAULT_LOCALE;
}

export function resolveInitialLocale() {
  let stored = null;
  try {
    stored = window.localStorage.getItem(STORAGE_KEY);
  } catch (error) {
    // Throws in Safari private mode; fall through to detection.
  }
  return isSupported(stored) ? stored : detectBrowserLocale();
}

export function persistLocale(code) {
  try {
    window.localStorage.setItem(STORAGE_KEY, code);
  } catch (error) {
    // Preference just won't survive a reload.
  }
}
